import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const before = ['Hours lost rewriting a class plan every single week', 'Freezing up when your mind goes blank mid-class', 'Guessing which adaptations are actually safe for real bodies', 'Feeling like an imposter despite finishing your certification', 'Piecing together cues, scripts, and structure from a dozen sources'];
const after = ['A full library of ready-to-teach beginner sequences', 'A script vault for the exact moments your mind goes blank', 'Clear, real-body adaptations for common physical limitations', 'A mindset system built specifically for newly certified teachers', 'One coherent toolkit — sequences, cueing, and confidence in one place'];
export function BeforeAfter() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-18" data-mp="2vr3uslu021hf">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="2vrvr5yvf838r">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-20" data-mp="30qow32wn6lxb">
          The Cost of Starting From Scratch
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-21" data-mp="x2qx3l1dhdyt">
          <div className="rounded-4xl border border-terracotta/20 bg-cream-card p-7 sm:p-9" data-id="element-22" data-mp="t3qdw1ezg9ba">
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-terracotta" data-id="element-23" data-mp="172zuh273p5fs">
              Before
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-24" data-mp="1246gz9rtdefm">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-25" data-mp="ef3y5ylg1fjj">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-terracotta-tint" data-id="element-26" data-mp="9f9as50vn838">
                    <XIcon className="h-3.5 w-3.5 text-terracotta" aria-hidden="true" data-id="element-27" data-mp="o4xa50phzwob" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-ink-soft" data-id="element-28" data-mp="jcdpjjse81a0">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-4xl border border-sage/30 bg-teal p-7 sm:p-9" data-id="element-29" data-mp="3mu5o5h11bjh6">
            <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-sage-tint" data-id="element-30" data-mp="1qqr4e75eqjya">
              With Yoga With Tina
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-31" data-mp="1vosngs2u2j9r">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-32" data-mp="20g0z7urmygq3">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-sage/30" data-id="element-33" data-mp="20iwx5j3hh5ej">
                    <CheckIcon className="h-3.5 w-3.5 text-cream" aria-hidden="true" data-id="element-34" data-mp="17s54gvlmmyvy" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-cream/90" data-id="element-35" data-mp="1cq6kf7nrai37">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base font-medium leading-relaxed text-teal sm:text-lg" data-id="element-36" data-mp="1lrmx5m21mwal">
          A complete teaching system to prepare less and teach beginner yoga with more confidence.
        </p>
      </div>
    </section>;
}